import { provideHttpClient, withInterceptors, withJsonpSupport } from '@angular/common/http';
import { ApplicationConfig, provideBrowserGlobalErrorListeners } from '@angular/core';
import { provideRouter, withHashLocation } from '@angular/router';
import { providePinnaklEnvironment } from '@pinnakl/core/environment';
import { crmWorkspaceHeaderInterceptor } from '@pinnakl/crm/data-access';
import { providePinnaklPrimeNg, UiToastMessageService } from '@pinnakl/shared/ui/prime';
import { PinnaklUIToastMessage } from '@pinnakl/shared/util-providers';
import { MessageService } from 'primeng/api';
import { DialogService } from 'primeng/dynamicdialog';
import { routes } from './app.routes';
import { authInterceptor } from './auth/auth-interceptor';
import { environment } from './environments/environment';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes, withHashLocation()),
    provideHttpClient(withJsonpSupport(), withInterceptors([authInterceptor, crmWorkspaceHeaderInterceptor])),
    providePinnaklEnvironment(environment),
    providePinnaklPrimeNg(),
    DialogService,
    MessageService,
    {
      provide: PinnaklUIToastMessage,
      useClass: UiToastMessageService,
    },
  ],
};
